import { render, staticRenderFns } from "./NotifyInactiveDlg.vue?vue&type=template&id=0369a36f&"
import script from "./NotifyInactiveDlg.vue?vue&type=script&lang=js&"
export * from "./NotifyInactiveDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports